/* eslint-disable */
// @ts-nocheck 
import React from "react";
import { Box, Typography } from "@mui/material";
import "./TaskBox.css";
import { useDrag, useDrop } from "react-dnd";

import { fonts } from "../../themes/themes";

export interface Task {
  id: number;
  title: string;
  status: string;
}

interface TaskBoxProps extends Task {
  onDrop: (id: number, newStatus: string) => void;
}
interface contentTileType {
  goalName?: string;
  goalProgress?: string;
  daysLeft?: any;
  onClickEdit?: any;
  onClick?: any;
}
const TaskBox: React.FC<contentTileType & TaskBoxProps> = ({
  daysLeft,
  goalName,
  goalProgress,
  onClickEdit,
  onClick,
  id,
  onDrop,
  status,
  title,
}) => {
  const [{ isDragging }, drag] = useDrag({
    type: "TASK",
    item: { id, title, status },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });

  const [, drop] = useDrop({
    accept: "TASK",
    hover: (item: any) => {
      if (item.status !== status) {
        onDrop(item.id, status);
        item.status = status; // Update the status to prevent continuous drops
      }
    },
  });
  return (
    <div ref={(node) => drag(drop(node))} style={{ cursor: "move" }}>
      <Box className="main_task_box" onClick={onClick}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography
            style={{
              fontFamily: fonts.fontFamily,
              color: "black",
              fontWeight: "bold",
              fontSize: "1em",
            }}
          >
            {title}
          </Typography>

          <Typography className="edit_btn_perf" onClick={onClickEdit}>
            <i className="las la-pencil-alt" />
          </Typography>
        </Box>
        <Box style={{ marginTop: "0.5em" }}>
          <Typography
            style={{
              fontFamily: fonts.fontFamily,
              color: "black",
              fontWeight: "bold",
              fontSize: "0.725em",
            }}
          >
            <span style={{ color: "#9E9E9E" }}>Start Date:</span> 13/01/2023 |
            Priority: <span style={{ color: "#4CAF50" }}>Low</span>
          </Typography>
        </Box>
        <Box style={{ marginTop: "0.5em" }}>
          <Typography
            style={{
              fontFamily: fonts.fontFamily,
              color: "black",

              fontSize: "0.725em",
            }}
          >
            Login Screen, Signup, Forgot password, Error message
          </Typography>
        </Box>
        <Box
          style={{
            backgroundColor: "#4CAF50",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "5px",
            width: "6vw",
            height: "auto",
            borderRadius: "8px",
            marginTop: "0.5em",
          }}
        >
          <i
            className="las la-clock"
            style={{
              fontFamily: fonts.fontFamily,
              color: "white",

              fontSize: "0.725em",
            }}
          />
          <Typography
            style={{
              fontFamily: fonts.fontFamily,
              color: "white",

              fontSize: "0.725em",
            }}
          >
            Mar 25, 2022
          </Typography>
        </Box>
      </Box>
    </div>
  );
};

export default TaskBox;
